import { Type } from 'class-transformer';
import { IsArray, IsDefined, IsIn, IsOptional, ValidateNested } from 'class-validator';
import { BaseDto } from '../../@base/base.dto';
import { ContactInfosDto, PostalAddressDto } from '../../administrative';
import { UserRole } from '../../keycloak';
import { AgentProfileId, OwnerProfileId, UserId } from '../../types';
import { UserIdentityPopulateAvatarDto } from './populate/user-identity-populate-avatar.dto';
import { UserMetadataDto } from './user-metadata.dto';
import { UserResponsivenessDto } from './user-responsiveness.dto';
import { UserSettingsDto } from './user-settings.dto';
import { UserSubscriptionDto } from './user-subscription.dto';

export class UserDto extends BaseDto<UserId> {
  @ValidateNested()
  @Type(() => UserIdentityPopulateAvatarDto)
  identity!: UserIdentityPopulateAvatarDto;

  @IsOptional()
  @ValidateNested()
  @Type(() => PostalAddressDto)
  address?: PostalAddressDto;

  @ValidateNested()
  @Type(() => ContactInfosDto)
  @IsDefined()
  contactInfos!: ContactInfosDto;

  @ValidateNested()
  @Type(() => UserSettingsDto)
  settings!: UserSettingsDto;

  @IsDefined()
  @IsArray()
  @IsIn(Object.values(UserRole), { each: true })
  roles!: UserRole[];

  @ValidateNested()
  @Type(() => UserMetadataDto)
  @IsDefined()
  metadata!: UserMetadataDto;

  @IsOptional()
  @ValidateNested()
  @Type(() => UserSubscriptionDto)
  subscription?: UserSubscriptionDto;

  @IsOptional()
  @ValidateNested()
  @Type(() => UserResponsivenessDto)
  responsiveness?: UserResponsivenessDto;

  @IsOptional()
  profiles?: {
    agent?: AgentProfileId;
    owner?: OwnerProfileId;
  };
}
